// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Breadcrumbs__Wrapper_1XGWg","Arrow":"Breadcrumbs__Arrow_35rms d-md-none","Item":"Breadcrumbs__Item_1_LsS"};